var render = function render(){var _vm=this,_c=_vm._self._c;return _c('epc-modal-wrapper',{attrs:{"active":_vm.isModalActive,"title":_vm.$t('upload_image'),"width":480},on:{"update:active":function($event){_vm.isModalActive=$event}}},[_c('report-image-upload-form',{ref:"form",attrs:{"is-gantt":_vm.isGantt,"show-caption":_vm.showCaption},on:{"submit":_vm.onSubmit,"cancel":_vm.hide}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }